import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import AccountHolderPropertiesPanel from "./panels/AccountHolderPropertiesPanel";
import AccountPropertiesPanel from "./panels/AccountPropertiesPanel";
import AccountPageView from "./views/AccountPageView";
import VipTag from "./shared/VipTag";
import {List} from "immutable";
import "./AccountPage.css";

class AccountPage extends Component {

  constructor(props) {
    super(props);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.state = {
      selectedPanelId: "account"
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = <span>Account <VipTag show={this.props.vip} /></span>;

    return (
      <div className="AccountPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Account" id="account" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Account Holder" id="customer" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Add Product to Cart" 
              onClick={this.handleAddProductToCart.bind(this)} />          
            <ActionButton 
              label="Add Subscription to Cart" 
              onClick={this.handleAddSubscriptionToCart.bind(this)} />          
            <ActionButton 
              label="Rename Account" 
              onClick={this.handleRenameAccount.bind(this)} />
            <ActionButton 
              label="Set Billing Address" 
              onClick={this.handleSetBillingAddress.bind(this)} />
            <ActionButton 
              label="Set Tax Information" 
              onClick={this.handleSetTaxInformation.bind(this)} />
            <ActionButton 
              label="Set Tax Exemption" 
              onClick={this.handleSetTaxExemption.bind(this)} />
            <ActionButton
              label="Set Payment Terms"
              onClick={this.handleSetPaymentTerms.bind(this)} />
            <ActionButton
              label="Set Payment: Credit Card"
              onClick={this.handleSetPaymentCreditCard.bind(this)} />
            <ActionButton
              label="Set Billing Status" 
              onClick={this.handleChangeBillingStatus.bind(this)} />
            <ActionButton 
              label="Change Cart Policies" 
              show={false}
              onClick={this.handleChangeCartPolicies.bind(this)} />
            <ActionButton
              label="Assign VIP Status"
              active={!!this.props.customerId}
              onClick={this.handleAssignCustomerVipStatus.bind(this)} />
            <ActionButton
              label="Unassign VIP Status"
              active={!!this.props.customerId}
              onClick={this.handleUnassignCustomerVipStatus.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "account":
        return (
          <AccountPageView 
            accountId={this.props.accountId}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }


  renderPanels(page) {
    switch(page) {
      case "account":
        if (this.state.selectedPanelId === "account") {
          return this.buildPanels(List([AccountPropertiesPanel]));
        } else {
          return this.buildPanels(List([AccountHolderPropertiesPanel]));
        }

      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case AccountHolderPropertiesPanel:
        return <AccountHolderPropertiesPanel
                key="AccountHolderPropertiesPanel"
                expanded={true}
                accountId={this.props.accountId}
                />

      case AccountPropertiesPanel:
        return <AccountPropertiesPanel
                key="AccountPropertiesPanel"
                expanded={true}
                accountId={this.props.accountId}
                hasSelection={true}
                />

      default:
        return null;      
    }
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  

  handleRenameAccount() {
    this.props.requestRenameAccount(this.props.accountId); 
  }

  handleSetBillingAddress() {
    this.props.requestChangeBillingAddress(this.props.accountId);
  }

  handleSetTaxInformation() {
    this.props.requestSetTaxInfo(this.props.accountId);
  }

  handleSetTaxExemption() {
    this.props.requestSetTaxExemption(this.props.accountId);
  }

  handleSetPaymentTerms() {
    this.props.requestSetPaymentTerms(this.props.accountId);
  }

  handleSetPaymentCreditCard() {
    this.props.requestSetPaymentCreditCard(this.props.accountId);
  }

  handleChangeBillingStatus() {
    this.props.requestChangeBillingStatus(this.props.accountId);
  }  

  handleChangeCartPolicies() {
    this.props.requestChangeCartPolicies(this.props.accountId);
  }  

  handleAddProductToCart() {
    this.props.requestAddProductToCart(this.props.accountId);
  }

  handleAddSubscriptionToCart() {
    this.props.requestAddSubscriptionToCart(this.props.accountId); 
  }

  handleAssignCustomerVipStatus() {
    this.props.requestAssignCustomerVipStatus(this.props.customerId);
  }

  handleUnassignCustomerVipStatus() {
    this.props.requestUnassignCustomerVipStatus(this.props.customerId);
  }

  handleBack() {
    this.props.router.push(`/customers`);
  }  
}

export default AccountPage;
